module.exports = __webpack_public_path__ + "img/egg-6.af577f48.svg";